import { atom } from 'recoil';

const autoPositionedTextIndicesState = atom({
  key: 'autoPositionedTextIndicesState',
  default: {}
});

export default autoPositionedTextIndicesState;